module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-mv-bbed4e4640cb86b9b45ef5aeffad2006.jpg";